import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-message" }
const _hoisted_2 = { class: "table-message__title" }
const _hoisted_3 = { class: "table-message__subtitle" }

interface Props {
  title?: string;
  subtitle?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableEmptyData',
  props: {
    title: { default: "Нет данных для отображения" },
    subtitle: { default: "Данные по указанным регионам за выбранный\nпериод еще не загружены в систему" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.subtitle), 1)
  ]))
}
}

})